export default __webpack_public_path__ + "static/media/nabetasadof.a94f5e48.jpg";